import React, { useState } from "react";
import { AccessTierProvider } from "contexts/AccessTierContext";
import InContentAIHeader from "./shared/InContent/InContentAIHeader";
import InContentAskLitchartsAI from "./InContentAskLitchartsAI";
import { AI_TOOL_NAMES, AI_TOOL_READABLE_NAMES } from "./constants";

const InContentTools = (props) => {
  const [selectedTool, setSelectedTool] = useState(props.headerOptions[0]);
  const [askAiQuota, setAskAiQuota] = useState(props.askAi.quotaRemaining);
  const [discussionQuota, setDiscussionQuota] = useState(
    props.discussionQuestionGenerator.quotaRemaining
  );
  return (
    <AccessTierProvider accessTier={props.accessTier}>
      <div className="ask-litcharts-ai--in-content-container">
        <InContentAIHeader
          options={props.headerOptions}
          selectedOption={selectedTool}
          onSelect={setSelectedTool}
        />
        {selectedTool?.full === AI_TOOL_READABLE_NAMES.ASK_AI && (
          <InContentAskLitchartsAI
            toolName={AI_TOOL_NAMES.ASK_AI}
            {...props.askAi}
            quotaRemaining={askAiQuota}
            onQuotaChange={setAskAiQuota}
          />
        )}
        {selectedTool?.full === AI_TOOL_READABLE_NAMES.DISCUSSION_QUESTIONS && (
          <InContentAskLitchartsAI
            toolName={AI_TOOL_NAMES.DISCUSSION_QUESTIONS}
            {...props.discussionQuestionGenerator}
            quotaRemaining={discussionQuota}
            onQuotaChange={setDiscussionQuota}
          />
        )}
      </div>
    </AccessTierProvider>
  );
};

export default InContentTools;
